import { portlessRedirect } from './environments/local-service-url';

// Set by `ng serve --define` in the dev:app scripts; undefined in every other build.
declare const PORTLESS_URL: string | undefined;

const target = portlessRedirect(window.location.href, typeof PORTLESS_URL === 'string' ? PORTLESS_URL : '');
if (target) {
    window.location.replace(target);
}
